import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmlcanvaselement" id="htmlcanvaselement"></a>
    <h1 {...{
      "id": "windowhtmlcanvaselement"
    }}>{`window.HTMLCanvasElement`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement"
      }}>{`Web APIs - HTMLCanvasElement`}</a>{` for more details`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`UXP HTMLCanvasElement supports only basic shapes for now.`}</p>
    <p>{`Also, refer the following interfaces`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../HTML%20DOM/CanvasRenderingContext2D.md#module:global.canvasrenderingcontext2d"
        }}>{`CanvasRenderingContext2D`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../HTML%20DOM/CanvasGradient.md#module:global.canvasgradient"
        }}>{`CanvasGradient`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../HTML%20DOM/Path2D.md#module:global.path2d"
        }}>{`Path2D`}</a><br parentName="li"></br>
        <strong parentName="li">{`Since`}</strong>{`: v7.0.0  `}</li>
    </ol>
    <a name="htmlcanvaselement-height" id="htmlcanvaselement-height"></a>
    <h2 {...{
      "id": "height--number"
    }}>{`height : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Get the height of the canvas element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/height"
      }}>{`HTMLCanvasElement - height`}</a>{` for more details  `}</p>
    <a name="htmlcanvaselement-width" id="htmlcanvaselement-width"></a>
    <h2 {...{
      "id": "width--number"
    }}>{`width : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Get the width of the canvas element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/width"
      }}>{`HTMLCanvasElement - width`}</a>{` for more details  `}</p>
    <a name="htmlcanvaselement-getcontext" id="htmlcanvaselement-getcontext"></a>
    <h2 {...{
      "id": "getcontextcontexttype"
    }}>{`getContext(contextType)`}</h2>
    <p>{`Creates a 2D drawing context on the canvas.`}</p>
    <br></br> Note: Only '2d' context is supported.
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`CanvasRenderingContext2D`}</inlineCode>{` - A 2D rendering context (CanvasRenderingContext2D) object.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext"
      }}>{`HTMLCanvasElement - getContext()`}</a>{` for more details`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`contextType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string containing the context identifier defining the drawing context associated to the canvas. Supports only '2d'.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// 1. Provide the canvas tag in your HTML document.
  <sp-body id="layers">
    <canvas id="canvas" height="230" width="1500"></canvas>
  </sp-body>
  <footer>
  <!-- Button Events to invoke height, width and context of canvas -->
    <sp-button id="btnPopulateLoadScript" onclick="show_height()">Canvas Height</sp-button>
    <sp-button id="btnPopulateLoadScript" onclick="show_width()">Canvas Width</sp-button>
    <sp-button id="btnPopulateLoadScript" onclick="getContext()">Get Context</sp-button>
  </footer>
// 2. You can now get the width, height and context using JavaScript under <script> tag, as shown below.
<script>
  const canvas = document.getElementById("canvas");

  function show_height() {
    console.log("Canvas Height: "+ canvas.height);
  }

  function show_width() {
    console.log("Canvas Width: "+ canvas.width);
  }

  // Function to get the canvas context and draw a triangle using lines
  function getContext() {
     let context = canvas.getContext("2d"); // get's the canvas context

     // Draw a triangle. For more details on the below apis refer to interfaces such as CanvasRenderingContext2D, CanvasGradient. The details of the interfaces are shared as a link at the top of this documentation
     context.beginPath();
     context.moveTo(50,50);
     context.lineTo(100, 50);
     context.lineTo(100, 100);
     context.lineTo(50,50)
     context.closePath();
     context.stroke();
  }
</script>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      